import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isRanking", "innerRef"];

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { TableBodyCell } from '../TableCell';
var rankingStyles = css({
  boxSizing: 'border-box'
});
export var RankableTableBodyCell = function RankableTableBodyCell(_ref) {
  var isRanking = _ref.isRanking,
      innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return jsx(TableBodyCell, _extends({
    css: isRanking && rankingStyles
  }, props, {
    innerRef: innerRef
  }));
};